import styled from 'styled-components';
import { Colors } from '../../utils/colors';
import { Sizes } from '../../utils/sizes';

export const PageContainer = styled.section`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, ${Colors.background} 0%, ${Colors.surface} 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
`;

export const Card = styled.form`
  width: 100%;
  max-width: 440px;
  background: rgba(20, 20, 20, 0.6);
  border: 1px solid ${Colors.gold};
  border-radius: 12px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 28px 20px;
  }
`;

export const Title = styled.h1`
  color: ${Colors.yellow};
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: ${Colors.gold};
  font-size: 14px;
  margin: 0 0 16px 0;
  text-align: center;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: ${Colors.white};
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;

  & input {
    padding: 12px 14px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid ${Colors.gold};
    border-radius: 6px;
    color: ${Colors.white};
    font-size: 15px;
    font-weight: 500;
    text-transform: none;
    transition: border-color 0.2s ease;
    min-height: 46px;

    &:focus {
      outline: none;
      border-color: ${Colors.yellow};
    }

    &::placeholder {
      color: rgba(255, 215, 0, 0.5);
    }
  }
`;

export const SubmitButton = styled.button`
  margin-top: 8px;
  padding: 14px;
  background: ${Colors.yellow};
  color: ${Colors.dark};
  border: none;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
  transition: transform 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
`;

export const SwitchLink = styled.p`
  text-align: center;
  color: ${Colors.gold};
  font-size: 13px;
  margin: 8px 0 0 0;

  & a {
    color: ${Colors.yellow};
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const ErrorBox = styled.div`
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #ef4444;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
`;

export const SuccessBox = styled.div`
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid #22c55e;
  color: #22c55e;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
`;

export const ForgotPasswordLink = styled.button`
  background: none;
  border: none;
  color: ${Colors.gold};
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  margin: 4px 0 8px 0;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: ${Colors.yellow};
  }

  &:focus-visible {
    outline: 2px solid ${Colors.yellow};
    outline-offset: 2px;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  opacity: ${(p) => (p.$isOpen ? 1 : 0)};
  visibility: ${(p) => (p.$isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const ModalContent = styled.div`
  background: linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%);
  border: 1px solid ${Colors.gold};
  border-radius: 12px;
  padding: 40px 32px;
  max-width: 440px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  transform: ${(p) => (p.$isOpen ? 'scale(1)' : 'scale(0.95)')};
  transition: transform 0.3s ease;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: ${Colors.gold};
  font-size: 24px;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.2s ease;

  &:hover {
    color: ${Colors.yellow};
  }

  &:focus-visible {
    outline: 2px solid ${Colors.yellow};
    outline-offset: 2px;
  }
`;

